import SpinnerIcon from 'shared/icons/SpinnerIcon'

type LoadingIndicatorProps = {
  text: string
}

const LoadingIndicator = (props: LoadingIndicatorProps) => {
  const { text = 'Loading...' } = props

  return (
    <div className="inline-flex w-full items-center justify-center gap-2 p-6">
      <SpinnerIcon />
      <span>{text}</span>
    </div>
  )
}

export default LoadingIndicator
